import React from "react";
import { Table } from "react-bootstrap";

const MyPaintings = () => {
  const paintings = [
    {
      sNo: 1,
      title: "Starry Night",
      artistName: "Vincent van Gogh",
      year: "1889",
      medium: "Oil on canvas",
      dimensions: "73.7 cm × 92.1 cm",
      description:
        "A depiction of the view from the east-facing window of his asylum room at Saint-Rémy-de-Provence.",
      category: "Post-Impressionism",
      price: "$100 million",
      image: "starry_night.jpg",
      availability: "Not for sale",
    },
    {
      sNo: 2,
      title: "Mona Lisa",
      artistName: "Leonardo da Vinci",
      year: "1503",
      medium: "Oil on poplar panel",
      dimensions: "77 cm × 53 cm",
      description:
        "A portrait of Lisa Gherardini, the wife of Francesco del Giocondo.",
      category: "Renaissance",
      price: "Priceless",
      image: "mona_lisa.jpg",
      availability: "Not for sale",
    },
    // Add more paintings as needed
  ];
  return (
    <div className="dashboard-pages-padding">
      <h1>My All Paintings</h1>
      <div className="tableDiv">
        <Table responsive>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Title</th>
              <th>Medium</th>
              <th>Dimensions</th>
              <th>Description</th>
              <th>Category</th>
              <th>Price</th>
              <th>Image</th>
              <th>Availability</th>
            </tr>
          </thead>
          <tbody>
            {paintings.map((painting, index) => (
              <tr key={index}>
                <td>{painting.sNo}</td>
                <td>{painting.title}</td>
                <td>{painting.medium}</td>
                <td>{painting.dimensions}</td>
                <td>{painting.description}</td>
                <td>{painting.category}</td>
                <td>{painting.price}</td>
                <td>{painting.image}</td>
                <td>{painting.availability}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default MyPaintings;
